module.exports = __webpack_public_path__ + "img/example6.93b468b5.jpg";